import {getBaseDomain} from './domain';

const isIpHost = (hostname: string): boolean => /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname);
const envSubdomains = new Set(['setup', 'staging', 'dev']);

const isEnvBaseDomain = (baseDomain: string): boolean => {
    const parts = baseDomain.split('.').filter(Boolean);
    if (parts.length < 3) return false;
    return envSubdomains.has(parts[0] ?? '');
};

export const getAdminHost = (hostname: string): string => {
    const trimmed = hostname.trim();
    if (!trimmed) return hostname;
    if (trimmed === 'localhost' || isIpHost(trimmed)) return trimmed;
    const baseDomain = getBaseDomain(trimmed);
    if (!baseDomain || baseDomain === trimmed) return trimmed;
    if (isEnvBaseDomain(baseDomain)) return baseDomain;
    return `dashboard.${baseDomain}`;
};

export const buildAdminOrigin = (location: Pick<Location, 'protocol' | 'hostname' | 'port'>): string => {
    const portSuffix = location.port ? `:${location.port}` : '';
    const adminHost = getAdminHost(location.hostname);
    return `${location.protocol}//${adminHost}${portSuffix}`;
};
